// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import Vuex from 'vuex'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'

import App from './App'
import router from './router'
import store from './store'

import 'bootstrap'

Vue.use(BootstrapVue)

Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.use(VueResource)
Vue.http.options.root = process.env.API

Vue.http.interceptors.push(function(request, next) {
  // read token en put in request
  // TODO: si pas de token essayer de le récupérer ?
  const token = localStorage.getItem('authToken')

  // modify headers
  request.headers.set('X-CSRF-TOKEN', token)
  request.headers.set('Authorization', `Bearer ${token}`)

  // continue to next interceptor
  next(res => {
    // Unauthorized Access
    if (res.status === 401) {
      store.dispatch('flash', {
        message: 'Sorry, you are not autorized to do this action',
        type: 'warning'
      })
    } else if (res.status === 500) {
      store.dispatch('flash', {
        message:
          'Sorry we encountered an internal error with the server, please try again later',
        type: 'error'
      })
    }
  })
})

store.dispatch('checkAuth').finally(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
})



// WEBPACK FOOTER //
// ./src/main.js